import { For, type JSX } from 'cdui-js';
import i18n from '../../../i18n';
import { formatStockLineLabel, formatStockQuantity, type StockTransferLineItem } from './shared';

export type StiInfoRowProps = {
  label: string;
  value: string;
  valueClass?: string;
};

export const StiInfoRow = (props: StiInfoRowProps) => (
  <div class="sti-confirm-row">
    <div class="sti-confirm-label">{props.label}</div>
    <div class={`sti-confirm-value${props.valueClass ? ` ${props.valueClass}` : ''}`.trim()}>{props.value}</div>
  </div>
);

export type StiInfoSectionHeadProps = {
  title: string;
  action?: JSX.Element;
};

export const StiInfoSectionHead = (props: StiInfoSectionHeadProps) => (
  <div class="sti-confirm-section-head">
    <div class="sti-info-section-title">{props.title}</div>
    {props.action}
  </div>
);

export type StiStockInfoCardsProps = {
  stocks: StockTransferLineItem[];
};

export const StiStockInfoCards = (props: StiStockInfoCardsProps) => (
  <div class="sti-info-card-list">
    <For each={props.stocks}>
      {(item, index) => (
        <div class="sti-info-card">
          <StiInfoRow label={i18n.StockTransferIn.ColSerial} value={String(index() + 1).padStart(2, '0')} />
          <StiInfoRow label={i18n.StockTransferIn.ColNameCode} value={formatStockLineLabel(item)} />
          <StiInfoRow label={i18n.StockTransferIn.ColQuantity} value={formatStockQuantity(item.quantity)} />
        </div>
      )}
    </For>
  </div>
);
